import React, { useEffect, useState } from 'react'
import Skeleton from 'react-loading-skeleton';
import SEO from '../components/Seo';
import TitleTextButton from '../modules/TitleTextButton';
import ImageTitleTextButton from '../modules/ImageTitleTextButton';
import DokumenteSlider from '../components/DokumenteSlider';
import Header_2 from '../headers/Header_2';
import Button from '../components/Button';
import { BlocksRenderer } from '@strapi/blocks-react-renderer';
import FaqMoldule from '../modules/FaqModule';
import MedienPopupSlider from '../components/MedienPopupSlider';
import ImageBeforeAfter from '../modules/ImageBeforeAfter';
import ThemenModule from '../modules/ThemenModule';

export const NachhaltigkeitZahlen = () => {


    const [isLoading, setIsLoading] = useState(false);
    const [pageData, setPageData] = useState(null);
    const [modules, setModules] = useState(null);
    const [headerModules, setHeaderModules] = useState(null);

    const [metaData, setMetaData] = useState(null);

    const getPageData = async () => {
        setIsLoading(true)
        try {
            const response = await fetch("https://backend.bgzurlinden.ch/api/nachhaltigkeit-in-zahlen?populate[Bannerbereich][on][header.header-2-text-bild][populate][Bild]=true&populate[Bannerbereich][on][header.header-2-text-bild][populate][Videominiatur]=true&populate[Bannerbereich][on][header.header-2-text-bild][populate][Video]=true&populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Bild]=true&populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Videominiatur]=true&populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Video]=true&populate[Modul][on][modules.short-titel-titel-text-button][populate][Button][populate]=*&populate[Modul][on][modules.short-titel-titel-text-button][populate][PDF][populate]=*&populate[Modul][on][modules.carousel-bild-re-text][populate][Bild]=true&populate[Modul][on][modules.carousel-bild-re-text][populate][Button][populate]=*&populate[Modul][on][modules.carousel-bild-re-text][populate][Videominiatur][populate]=*&populate[Modul][on][modules.carousel-bild-re-text][populate][Video][populate]=*&populate[Modul][on][modules.schnellabspruenge-modul][populate][Schnellabspruenge][populate][Button][populate]=true&populate[Modul][on][modules.faq][populate][FAQ_Data][populate]=*&populate[Modul][on][modules.bild-info][populate][Bild_Info_Daten][populate][Bild][populate]=true&populate[Modul][on][modules.vorher-nachher-bild-und-text][populate][Vorher_Bild]=true&populate[Modul][on][modules.vorher-nachher-bild-und-text][populate][Nachbild]=true&populate[Modul][on][modules.bild-pdf][populate][PDF][populate][PDF][populate]=true&populate[Modul][on][modules.bild-pdf][populate][Bild][populate]=true&populate[Modul][on][modules.bild-pdf][populate][Button][populate]=true&populate[Modul][on][modules.benefits][populate][Benefits_Data][populate][Icon][populate]=true&populate[Modul][on][modules.themenmodul-komplett][populate][Themen][populate][Bild]=true&populate[Modul][on][modules.themenmodul-komplett][populate][Themen][populate][Video]=true&populate[Modul][on][modules.themenmodul-komplett][populate][Themen][populate][Videominiatur]=true&populate[Modul][on][modules.themenmodul-komplett][populate][Themen][populate][PDF][populate][PDF]=true&populate[Modul][on][modules.themenmodul-komplett][populate][Themen][populate][Button]=true&populate[Modul][on][modules.facts-modul][populate][Facts][populate][Icon][populate]=*&populate[Modul][on][modules.dokument-modul][populate][Dokument_Modul][populate][icon]=true&populate[Modul][on][modules.dokument-modul][populate][Dokument_Modul][populate][PDF][populate][PDF][populate]=true&populate[Metadaten]=*");


            const data = await response.json();
            console.log(data?.data?.Modul);

            if (data.data) {
                setPageData(data.data);
                setMetaData(data.data?.Metadaten);
                setModules(data?.data?.Modul);
                setHeaderModules(data?.data?.Bannerbereich);

                const bildInfoModule = data?.data?.Modul?.find(
                    (module) => module.__component === "modules.bild-info"
                );

                fetchImages([bildInfoModule]);
            }
        }
        catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }

    }

    useEffect(() => {
        getPageData();
    }, [])

    const [imagesMap, setImagesMap] = useState({});

    const fetchImages = async (bildInfoData) => {
        try {

            console.log('Fetching images for bildInfoData', bildInfoData);

            const response = await fetch(
                `https://backend.bgzurlinden.ch/api/upload/files`
            );

            const data = await response.json();

            const mappedImages = {};

            bildInfoData?.forEach((item) => {

                const imageId = item?.Bild?.image;

                const matchedImage = data.find(
                    (img) => img.documentId === imageId
                );

                if (matchedImage) {
                    mappedImages[imageId] = matchedImage;
                }
            });

            setImagesMap(mappedImages);

        } catch (err) {
            console.log(err);
        }
    };

    const [popupData, setPopupData] = useState(null);
    const [popupColor, setPopupColor] = useState(null);
    const [show, setShow] = useState(false);

    const showPopup = (infoData, color) => {
        setPopupData(infoData);
        setPopupColor(color);
        setShow(true);
    };

    const closePopup = () => {
        setPopupData(null);
        setShow(false);
    };

    return (
        <div className='page-content'>
            {metaData && <SEO seoData={metaData} />}

            {show && popupData && (
                <div className="modal medien_modal show d-block">
                    <div className="modal-dialog modal-xl modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-body">
                                <button className="btn-close" onClick={closePopup}>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none" nighteye="disabled">
                                        <rect width="64" height="64" rx="32" fill={`var(--${popupColor})`} />
                                        <rect x="19.3203" y="21.1396" width="2.56" height="33.28" rx="1.28" transform="rotate(-45 19.3203 21.1396)" fill="white" />
                                        <rect x="42.8594" y="19.3301" width="2.56" height="33.28" rx="1.28" transform="rotate(45 42.8594 19.3301)" fill="white" />
                                    </svg>
                                </button>
                                <div className={`popup-container popup-${popupColor}`}>
                                    <div className='row'>
                                        <div className='col-lg-6 contnet-col'>
                                            <h2 className={`text-${popupColor} fs_50 fw-600`}>{popupData?.Titel}</h2>
                                            <h3 className="text-black fs_30 fw-600">{popupData?.Untertitel}</h3>
                                            {popupData?.Text && <BlocksRenderer content={popupData?.Text} />}
                                        </div>
                                        <div className='col-lg-6 image-col'>
                                            <MedienPopupSlider images={popupData?.Bild} showDownloadIcon={false} popupColor={popupColor} />
                                        </div>
                                        <div className='col-12 content-col mt-4 tick_list two_col'>
                                            {popupData?.Beschreibung && <BlocksRenderer content={popupData?.Beschreibung} />}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {!isLoading && (
                headerModules?.map((module, index) => (
                    <React.Fragment key={index}>
                        {module.__component === "header.header-2-text-bild" && (
                            <Header_2 module={module} isLoading={isLoading} title={module?.Titel} description={module?.Beschreibung} image={module?.Bild} sectionClass="banners-nachhaltigkeit" activePage='Nachhaltigkeit & Innovation' bgGray={false} />
                        )}
                    </React.Fragment>
                ))
            )}


            {!isLoading ? (
                modules?.map((module, index) => (
                    <React.Fragment key={index}>
                        {module.__component === "modules.short-titel-titel-text-button" &&
                            <section className={`pt-pb-10 sec-green-color ${module?.Padding_Top ? '' : 'pt-0'} ${module?.Padding_Bottom ? '' : 'pb-0'} ${module?.grauer_Hintergrundfarbe ? 'sec-bg-grey' : ''}`}>
                                <div className='container'>
                                    <TitleTextButton data={module} shortTitle={module?.Kurztitel} title={module?.Titel} text={module?.Text} buttons={module?.Button} component={module?.Komponente} pdf={module?.PDF} />
                                </div>
                            </section>
                        }
                        {module.__component === "modules.carousel-bild-re-text" &&
                            <ImageTitleTextButton module={module} shortTitle={module?.Kurztitel} images={module?.Bild} title={module?.Titel} description={module?.Beschreibung} buttons={module?.Button} sectionColor="green" imagePosition={module?.Bildposition} equalCol={module?.Gleiche_Spalten} />
                        }
                        {module.__component === "modules.faq" &&
                            <FaqMoldule module={module} sectionColor="green" />
                        }
                        {module.__component === "modules.vorher-nachher-bild-und-text" &&
                            <ImageBeforeAfter module={module} shortTitle={module?.Kurztitel} beforeImage={module?.Vorher_Bild} afterImage={module?.Nachbild} title={module?.Titel} description={module?.Beschreibung} buttons={module?.Button} sectionColor="green" imagePosition={module?.Bildposition} equalCol={module?.Gleiche_Spalten} />
                        }
                        {module.__component === "modules.themenmodul-komplett" &&
                            <ThemenModule module={module} sectionColor='green' />
                        }
                        {module.__component === "modules.benefits" &&
                            <section className='pb-10 sec-bg-grey sec-green-color'>
                                <div className='container'>
                                    <div className='row default-grid-gap job-card-row tabs-content'>
                                        {module?.Benefits_Data?.map((item, index) => (
                                            <div key={index} className='col-6 col-md-4 col-lg-3 col-item mt-4'>
                                                <div className="flip-card text-center position-relative">
                                                    <div className="flip-card-front">
                                                        <img src={`https://backend.bgzurlinden.ch${item.Icon?.url}`} alt={item?.Titel} />
                                                        <h4 lang='de' className='text-darkgrey fw-550 fs_24'>{item?.Titel}</h4>
                                                    </div>
                                                    <div className="flip-card-back">
                                                        <p lang="de">{item?.Text}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </section>
                        }
                        {module.__component === "modules.dokument-modul" &&
                            <section className='pb-10 sec-formulare-reglemente'>
                                <div className='container'>
                                    <div className='row formulare-reglemente-row'>
                                        {module?.Dokument_Modul?.map((dokument, index) => (
                                            <div className='col-sm-6 col-lg-3 col-item mt-4'>
                                                <div className='col-inner text-center'>
                                                    <img src={`https://backend.bgzurlinden.ch${dokument?.icon?.url}`} className='item-icon' alt='Statuten' />
                                                    <h3 className='text-darkgrey fs_30 fw-400 mb-3 mb-lg-4'>{dokument?.Titel}</h3>
                                                    <a className='pdf_download' target="_blank" rel="noopener noreferrer" href={`https://backend.bgzurlinden.ch${dokument?.PDF?.PDF?.url}`} download style={{ color: `var(--${dokument?.PDF?.button_farbe?.split(" ")[0]})` }}>
                                                        {/* <img src='images/icon-download.svg' alt='Download' /> */}

                                                        <div className='animate-icon'>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="21" viewBox="0 0 16 21" fill="none" nighteye="disabled">

                                                                <path className='path1' d="M7.99995 17.3644C7.81901 17.3644 7.63808 17.2988 7.49591 17.1642L1.34405 11.4746C1.03711 11.1924 1.01772 10.71 1.29559 10.3983C1.57345 10.0866 2.04841 10.0669 2.35536 10.3491L7.99995 15.5761L13.6445 10.3491C13.9515 10.0669 14.4232 10.0899 14.7043 10.3983C14.9822 10.71 14.9596 11.1891 14.6558 11.4746L8.50399 17.1675C8.36182 17.2988 8.18089 17.3644 7.99995 17.3644Z" style={{ fill: `var(--${dokument?.PDF?.button_farbe?.split(" ")[0]})` }} />
                                                                <path className='path2' d="M7.99995 17.3644C7.58638 17.3644 7.25039 17.0231 7.25039 16.6031V0.761249C7.25039 0.341249 7.58641 0 7.99998 0C8.41355 0 8.74958 0.341249 8.74958 0.761249V16.6031C8.74958 17.0264 8.41352 17.3644 7.99995 17.3644Z" style={{ fill: `var(--${dokument?.PDF?.button_farbe?.split(" ")[0]})` }} />

                                                                <path className='path3' d="M7.99995 17.3644C7.81901 17.3644 7.63808 17.2988 7.49591 17.1642L1.34405 11.4746C1.03711 11.1924 1.01772 10.71 1.29559 10.3983C1.57345 10.0866 2.04841 10.0669 2.35536 10.3491L7.99995 15.5761L13.6445 10.3491C13.9515 10.0669 14.4232 10.0899 14.7043 10.3983C14.9822 10.71 14.9596 11.1891 14.6558 11.4746L8.50399 17.1675C8.36182 17.2988 8.18089 17.3644 7.99995 17.3644Z" style={{ fill: `var(--${dokument?.PDF?.button_farbe?.split(" ")[0]})` }} />
                                                                <path className='path4' d="M7.99995 17.3644C7.58638 17.3644 7.25039 17.0231 7.25039 16.6031V0.761249C7.25039 0.341249 7.58641 0 7.99998 0C8.41355 0 8.74958 0.341249 8.74958 0.761249V16.6031C8.74958 17.0264 8.41352 17.3644 7.99995 17.3644Z" style={{ fill: `var(--${dokument?.PDF?.button_farbe?.split(" ")[0]})` }} />

                                                                <path d="M15.2504 21H0.749596C0.336026 21 0 20.6588 0 20.2388C0 19.8188 0.336026 19.4775 0.749596 19.4775H15.2504C15.664 19.4775 16 19.8188 16 20.2388C16 20.6588 15.664 21 15.2504 21Z" style={{ fill: `var(--${dokument?.PDF?.button_farbe?.split(" ")[0]})` }} />
                                                            </svg>
                                                        </div>

                                                        {dokument?.PDF?.button_text}
                                                    </a>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </section>
                        }
                        {module.__component === "modules.facts-modul" &&
                            <section className='sec-green-color sec-facts'>
                                <div className='container'>
                                    <div className='wohnen-zahlen-fakten'>
                                        <div className='row default-grid-gap mt-lg-4'>
                                            {module?.Facts?.map((item, index) => {

                                                return (
                                                    <div key={index} className='col-6 col-lg-3 mt-4 col-item' style={{ borderBottom: index >= module?.Facts?.length - (module?.Facts?.length % 4 || 4) ? 'none' : '1px solid #CFCFCF' }}>
                                                        <div className='col-inner'>
                                                            <img src={`https://backend.bgzurlinden.ch${item?.Icon?.url}`} alt='Baujahr' />
                                                            <h4 className="fw-450 fs_30">{item?.Titel}</h4>
                                                            <h2 className="text-green fw-550">{item?.Text}</h2>
                                                        </div>
                                                    </div>
                                                )

                                            })}
                                        </div>
                                    </div>
                                </div>
                            </section>
                        }
                        {module.__component === "modules.schnellabspruenge-modul" &&
                            <section className='pt-pb-10 sec-story-job sec-green-color'>
                                <div className='container'>
                                    <div className='row'>
                                        {module?.Schnellabspruenge?.map((item, index) => (
                                            <div key={index} className='col-lg-6 content-col mb-3 mb-lg-0'>
                                                <div className='col-inner fw_strong_500'>
                                                    <h2 className='text-black fw-500 mb-3'>{item?.Titel}</h2>
                                                    {item?.Text && <BlocksRenderer content={item?.Text} />}
                                                    <Button component={item?.Komponente} pdf={item?.PDF} buttons={item?.Button} />
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </section>
                        }
                        {module.__component === "modules.bild-pdf" &&
                            <section className={`pt-pb-10 sec-bgz-dokumente ${module?.Padding_Top ? '' : 'pt-0'} ${module?.Padding_Bottom ? '' : 'pb-0'} ${module?.grauer_Hintergrundfarbe ? 'sec-bg-grey' : ''}`}>
                                {/* <section className='sec-bgz-dokumente'> */}
                                <div className="container">
                                    <div className={`row ${module?.Bildposition !== 'Rechts' ? 'flex-lg-row-reverse' : ''}`}>
                                        <div className="col-lg-6">
                                            <div className="col-inner">
                                                <h3 className={`text-${module?.Modul_Farbe} fw-550 mb-4`}>{module?.Titel}</h3>
                                                <div className='download_list'>
                                                    {module?.PDF?.map((item, index) => (
                                                        <a className={`fs_26 fw-450 ${index === module?.PDF?.length - 1 ? 'border-0' : ""} ${item?.button_farbe?.split(" ")[0]}`} key={index} href={`https://backend.bgzurlinden.ch${item?.PDF?.url}`} download target="_blank" rel="noopener noreferrer" >{item?.button_text}
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="32" viewBox="0 0 24 32" fill="none">
                                                                <path d="M11.9999 26.46C11.7285 26.46 11.4571 26.36 11.2439 26.155L2.01608 17.485C1.55566 17.055 1.52658 16.32 1.94338 15.845C2.36018 15.37 3.07262 15.34 3.53304 15.77L11.9999 23.735L20.4668 15.77C20.9272 15.34 21.6348 15.375 22.0565 15.845C22.4733 16.32 22.4393 17.05 21.9838 17.485L12.756 26.16C12.5427 26.36 12.2713 26.46 11.9999 26.46Z" fill={`var(--${item?.button_farbe?.split(" ")[0]})`} />
                                                                <path d="M11.9999 26.46C11.3796 26.46 10.8756 25.94 10.8756 25.3V1.16C10.8756 0.519999 11.3796 0 12 0C12.6203 0 13.1244 0.519999 13.1244 1.16V25.3C13.1244 25.945 12.6203 26.46 11.9999 26.46Z" fill={`var(--${item?.button_farbe?.split(" ")[0]})`} />
                                                                <path d="M22.8756 32H1.12439C0.504039 32 0 31.48 0 30.84C0 30.2 0.504039 29.68 1.12439 29.68H22.8756C23.496 29.68 24 30.2 24 30.84C24 31.48 23.496 32 22.8756 32Z" fill={`var(--${item?.button_farbe?.split(" ")[0]})`} />
                                                            </svg>
                                                        </a>
                                                    ))}
                                                </div>
                                                {module?.Komponente_Button && <Button component={module?.Komponente} pdf={module?.PDF} buttons={module?.Button} />}
                                            </div>
                                        </div>
                                        <div className="col-lg-6 mt-4 mt-lg-0 img_col">
                                            <img src={`https://backend.bgzurlinden.ch${module?.Bild[0]?.url}`} className='w-100' alt='BGZ Dokumente' />
                                        </div>
                                    </div>
                                </div>
                            </section>
                        }
                        {module.__component === "modules.bild-info" &&
                            <section className='multiple-locations-sec pt-pb-10'>
                                <div className="container">
                                    {[module]?.map((item, index) => {

                                        const imageId = item?.Bild?.image;
                                        const image = imagesMap[imageId];

                                        return (
                                            <div key={index} className="hotspot-image-wrapper">

                                                <img
                                                    src={`https://backend.bgzurlinden.ch${image?.url}`}
                                                    alt=""
                                                    className="main-image"
                                                />

                                                {item?.Bild?.hotspots?.map((spot, i) => (
                                                    <button
                                                        key={spot.id}
                                                        className="hotspot-pin"
                                                        style={{
                                                            left: `${spot.x}%`,
                                                            top: `${spot.y}%`,
                                                            background: `var(--${item?.Bild_Info_Daten[i]?.Icon_Farbe?.split(" ")[0]})`,
                                                            animationName: `pulse-animation-${item?.Bild_Info_Daten[i]?.Icon_Farbe?.split(" ")[0]}`,
                                                        }}
                                                        onClick={() => showPopup(item?.Bild_Info_Daten[i], item?.Bild_Info_Daten[i]?.Icon_Farbe?.split(" ")[0])}
                                                    >
                                                        <img src="https://backend.bgzurlinden.ch/uploads/Group_1597881211_9751cd1a10.svg" alt="" />
                                                    </button>
                                                ))}

                                            </div>
                                        );
                                    })}
                                </div>
                            </section>
                        }
                    </React.Fragment>
                ))
            ) : (
                <>
                    <section className={`banner_sec inner_banner wohnen-banner position-relative`}>
                        <div className='container'>
                            <div className='row'>
                                <div className='col-md-5 col-lg-4 banner-content pt-pb-10'>
                                    <h1>{<Skeleton count={1} />}</h1>
                                    <p>{<Skeleton count={3} />}</p>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className={`pt-pb-10 sec-green-color`}>
                        <div className='container'>
                            <div className='title-text-button-module'>
                                {/* {shortTitle && <div className='subtitle'>{shortTitle}</div>} */}
                                <div className='row'>
                                    <div className='col-lg-5 title-col'>
                                        {/* {title && <h2 className='text-black mb-lg-4 mb-2'>{title}</h2>} */}
                                        <h2>{<Skeleton count={1} />}</h2>
                                    </div>
                                    <div className='col-lg-7 content-col mt-3 mt-lg-0 fw_strong_500'>
                                        <p>{<Skeleton count={3} />}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </>
            )}
        </div>
    )
}
